export class FeitoConferido {
  id: number;
  timestamp: string;
  username: string;
  description: string;
  action: string;
  entryType: string;
  content: string;
  entityModel: any;
}
